import { ChannelTypeEnum, ChatProviderIdEnum } from '../../../types';
import { UTM_CAMPAIGN_QUERY_PARAM } from '../../../ui';
import { chatWebhookConfig, getstreamConfig, grafanaOnCallConfig, msTeamsConfig, rocketChatConfig, slackConfigLegacy, telegramConfig, whatsAppBusinessConfig, } from '../credentials';
export const chatProviders = [
    {
        id: ChatProviderIdEnum.Novu,
        displayName: 'Novu Slack',
        channel: ChannelTypeEnum.CHAT,
        credentials: [],
        docReference: `https://docs.novu.co/platform/integrations/chat/slack${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'slack.svg', dark: 'slack.svg' },
    },
    {
        id: ChatProviderIdEnum.Slack,
        displayName: 'Slack',
        channel: ChannelTypeEnum.CHAT,
        credentials: slackConfigLegacy,
        docReference: `https://docs.novu.co/platform/integrations/chat/slack${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'slack.svg', dark: 'slack.svg' },
    },
    {
        id: ChatProviderIdEnum.Discord,
        displayName: 'Discord',
        channel: ChannelTypeEnum.CHAT,
        credentials: [],
        docReference: `https://docs.novu.co/platform/integrations/chat/discord${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'discord.svg', dark: 'discord.svg' },
    },
    {
        id: ChatProviderIdEnum.GrafanaOnCall,
        displayName: 'Grafana On Call Webhook',
        channel: ChannelTypeEnum.CHAT,
        credentials: grafanaOnCallConfig,
        docReference: 'https://grafana.com/docs/oncall/latest/integrations/webhook/',
        logoFileName: { light: 'grafana-on-call.png', dark: 'grafana-on-call.png' },
    },
    {
        id: ChatProviderIdEnum.MsTeams,
        displayName: 'MSTeams',
        channel: ChannelTypeEnum.CHAT,
        credentials: msTeamsConfig,
        docReference: `https://docs.novu.co/platform/integrations/chat/ms-teams${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'msteams.svg', dark: 'msteams.svg' },
    },
    {
        id: ChatProviderIdEnum.Mattermost,
        displayName: 'Mattermost',
        channel: ChannelTypeEnum.CHAT,
        credentials: [],
        docReference: 'https://developers.mattermost.com/integrate/webhooks/incoming/',
        logoFileName: { light: 'mattermost.svg', dark: 'mattermost.svg' },
    },
    {
        id: ChatProviderIdEnum.Ryver,
        displayName: 'Ryver',
        channel: ChannelTypeEnum.CHAT,
        credentials: [],
        docReference: 'https://api.ryver.com/ryvrest_api_examples.html#create-chat-message',
        logoFileName: { light: 'ryver.png', dark: 'ryver.png' },
    },
    {
        id: ChatProviderIdEnum.Zulip,
        displayName: 'Zulip',
        channel: ChannelTypeEnum.CHAT,
        credentials: [],
        docReference: `https://docs.novu.co/platform/integrations/chat/zulip${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'zulip.svg', dark: 'zulip.svg' },
    },
    {
        id: ChatProviderIdEnum.GetStream,
        displayName: 'GetStream',
        channel: ChannelTypeEnum.CHAT,
        credentials: getstreamConfig,
        docReference: 'https://getstream.io/chat/docs/node/?language=javascript',
        logoFileName: { light: 'getstream.svg', dark: 'getstream.svg' },
    },
    {
        id: ChatProviderIdEnum.RocketChat,
        displayName: 'Rocket.Chat',
        channel: ChannelTypeEnum.CHAT,
        credentials: rocketChatConfig,
        docReference: 'https://developer.rocket.chat/reference/api/rest-api/endpoints',
        logoFileName: { light: 'rocket-chat.svg', dark: 'rocket-chat.svg' },
    },
    {
        id: ChatProviderIdEnum.WhatsAppBusiness,
        displayName: 'WhatsApp Business',
        channel: ChannelTypeEnum.CHAT,
        credentials: whatsAppBusinessConfig,
        docReference: 'https://developers.facebook.com/docs/whatsapp/cloud-api',
        logoFileName: { light: 'whatsapp-business.svg', dark: 'whatsapp-business.svg' },
    },
    {
        id: ChatProviderIdEnum.ChatWebhook,
        displayName: 'Chat Webhook',
        channel: ChannelTypeEnum.CHAT,
        credentials: chatWebhookConfig,
        docReference: `https://docs.novu.co/channels-and-providers/chat/chat-webhook${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'chat-webhook.svg', dark: 'chat-webhook.svg' },
        betaVersion: true,
    },
    {
        id: ChatProviderIdEnum.Telegram,
        displayName: 'Telegram',
        channel: ChannelTypeEnum.CHAT,
        credentials: telegramConfig,
        docReference: `https://docs.novu.co/platform/integrations/chat/telegram${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'telegram.svg', dark: 'telegram.svg' },
    },
];
//# sourceMappingURL=chat.js.map